import { createContext, useContext, useState } from "react";

const VictimFormDataContext = createContext();

export const VictimFormDataProvider = ({ children }) => {
  const [victimData, setVictimData] = useState({});
  const [victimLogin, setVictimLogin] = useState({}); // 🔥 NEW FIELD

  const updateVictimData = (data) => {
    setVictimData(data);
  };

  const updateVictimLogin = (data) => {  // 🔥 NEW UPDATE FUNCTION
    setVictimLogin(data);
  };

  return (
    <VictimFormDataContext.Provider
      value={{
        victimData,
        updateVictimData,
        victimLogin,          // 🔥 added
        updateVictimLogin,    // 🔥 added
      }}
    >
      {children}
    </VictimFormDataContext.Provider>
  );
};

export const useVictimData = () => useContext(VictimFormDataContext);

